import { TabIds } from '~/definitions/tab';
import { getStore } from '~/mobx/AppStore';

const useTabChange = async (newTabId: TabIds) => {
    const { tabStore, candidateStore } = getStore();
    await tabStore.fetchTabData(newTabId);
    tabStore.setActiveTabId(newTabId);
    tabStore.setChangedTabId(newTabId);
    tabStore.setIsMenuOpened(false);
    tabStore.setIsTabContentReset(true);
    candidateStore.setIsCreateMode(false);
    candidateStore.setIsEditMode(false);
    candidateStore.resetDetailForm();
    candidateStore.setSelectedRegionIdForCopy('');
};

export default useTabChange;
